export default "__VITE_ASSET__$SPsRwxL__"